export const siteSettings = {
  name: "Option FX Stock Profit",
  link: "https://optfxstock.com",
  email: "support@optfxstock.com",
  appLink: "https://app.optfxstock.com",
};
